import { z } from "zod";

export const tagSchema = z.object({
  type: z.literal("tag"),
  id: z.string(),
  attributes: z.object({
    name: z.string(),
    entityType: z.string(),
    metadata: z.record(z.string()),
  }),
});

export type Tag = z.infer<typeof tagSchema>;

export const getTagsResponseSchema = z.object({
  data: z.array(tagSchema),
});

export type GetTagsResponse = z.infer<typeof getTagsResponseSchema>;

export const getTagsQuerySchema = z.object({
  entityType: z.string(),
});

export type GetTagsQuery = z.infer<typeof getTagsQuerySchema>;
